import { currentPage } from '../common/layout';
import { getM1FindVehicleEu, getM1FindVehicleUs, getM1FindVehicleByType } from '../common/shop/m1-find-vehicle-widget-loader';
import { getCoralCommentsCountUpdate } from '../common/utils/coral-requests-loader';
import '../common/jquery-snap-scroll';

currentPage.pageInit = ($page, pageData, pageId) => {
    const dataEdtn = document.body.dataset.edtn;
    $('.msnt-items-slider').snapScrollControl();
    
    $('.m1-model-anchors .m1-button').each((i, elem) => {
      const $elem = $(elem);
      const headerHeight = $('.m1-header-main').height();
      const scrollPadding = 16;

      $elem.on('click', (e) => {
        e.preventDefault();
        const $target = $($elem.attr('href'));

        if ($target.length) {
          $(document.scrollingElement).animate({"scrollTop": $target.offset().top - headerHeight - scrollPadding});
        }

        return false;
      });
    });

    let showHideButton = document.querySelector('#show-hide-button');
    let boxIsExpanded = false;
    
    if (showHideButton) {
        showHideButton.addEventListener('click', function(e) {
            e.preventDefault();
            boxIsExpanded = !boxIsExpanded;
            let hiddenPreview = document.querySelectorAll('.m1-submodel-rating');

            if (boxIsExpanded) {
                hiddenPreview.forEach((elem, elemIndex) => {
                    if (elemIndex > 5) {
                        elem.style.display = 'inline-block';
                    }
                });
                showHideButton.classList.add('active');
            } else {
                hiddenPreview.forEach((elem, elemIndex) => {
                    if (elemIndex > 5) {
                        elem.style.display = 'none';
                    }
                });
                showHideButton.classList.remove('active');
            }
        }); 
    }

    getM1FindVehicleEu().then((api) => {
        api.m1FindVehicleEu();
    });
    getM1FindVehicleUs().then((api) => {
        api.m1FindVehicleUs();
    });
	  getM1FindVehicleByType().then((api) => {
        api.m1FindVehicleByType();
    });
    getCoralCommentsCountUpdate().then((api) => {
        api.coralCommentsCountUpdate();
    });

    // Removed in phtml
    // if ($(".short-description").length > 0) {
    //     updateShortDescriptionBox();
    //     window.addEventListener("resize", updateShortDescriptionBox);
    // }
}